export const updatePermission = ({ userId, selectedRowKeys, dataSource }) => {
  return {
    userId: userId,
    privilegeAbmData: dataSource.map((item) => ({
      code: item.code,
      status: selectedRowKeys.includes(item.id) ? 'ACTIVE' : 'INACTIVE',
    })),
  };
};
